import React, { useState, useEffect } from "react";
import {
  IonGrid,
  IonIcon,
  IonRow,
  IonCol,
  isPlatform,
} from "@ionic/react";
import "./driverAssignFilter.scss";
import { CustomModalWeb } from "../../pages/userProfile/CustomModalWeb";
import { useTranslation } from "react-i18next";
import { loadCountFormatter } from "../../../utils/MyLoads.util";

export const DriverNameFilter = (props: any) => {
  const {t} = useTranslation();
  const allDrivers = {name:"All Drivers", partyId: "All_Drivers"};
  const [showList, setShowList] = useState(false);
  const [selected, setSelected] = useState(allDrivers);
  const driverFilterProps = {
    title: t("Assigned to"),
    contentAlignment : "left",
    buttons: [
      {
        title: t("Cancel"),
        type: "secondary-cta-btn-web",
        onClick: () => {
          {
            setSelected(props?.chosed)
            setShowList(false);
          }
        }
      },
      {
        title: t("Ok_TEXT"),
        type: "primary-cta-btn-web",
        onClick: () => {
          setShowList(false);
          props.onSelect(selected);
        }
      }
    ]
  };

  // useEffect(() => {
  //   if (isPlatform("desktop")) {
  //     if (
  //       props.segmentName === "Driver Assigned" ||
  //       props.segmentName === "Loads Assigned"
  //     ) {
  //       setDisplayText(props.filteredDriverNameD);
  //     }
  //     if (props.segmentName === "In-Transit") {
  //       setDisplayText(props.filteredDriverNameI);
  //     }
  //   }
  // }, [props.segmentName]);
  return (
    <>
      <IonGrid class="display-text-grid" data-testid='showDriverFilter' onClick={() => setShowList(true)}>
        { props?.chosed?.name} ({loadCountFormatter(props?.data?.length)})
        <IonIcon
          src="assets/icon/grid-down-arrow.svg"
          className="filter-icon"
          data-testid="filterIcon"
        />
      </IonGrid>
      <CustomModalWeb isModalOpen={showList} {...driverFilterProps}> 
          <IonGrid className="filter-values">
            {props.driverNameList.map((option: any, k: any) => (
              <IonRow
                className="dropdown-row cursor-pointer"
                key={k}
                onClick={() => setSelected(option)}
              >
                <IonCol class={option?.partyId === selected?.partyId ? "checked" : ""}>
                  {option?.name} <i className="check"></i>
                </IonCol>
              </IonRow>
            ))}
          </IonGrid>
      </CustomModalWeb>
    </>
  );
};
export default DriverNameFilter;
